module.exports = __webpack_public_path__ + "media/CheeseWire_Mobile.bf1717e2.mp4";